export default __webpack_public_path__ + "static/media/grotta.1c409549.webp";